import InsightsReporter from './insights/insightsReporter';
import sentryMonitoring from './sentry/sentryMonitoring';

const insiktReporter = new InsightsReporter();

export async function init() {
  try {
    await insiktReporter.connect();
  } catch (error) {
    console.warn(error);
  }

  try {
    await sentryMonitoring.init();
  } catch (error) {
    console.warn(error);
  }
}

export const getInsiktReporter = () => {
  return insiktReporter;
};
